import { useTranslation } from 'react-i18next';

import { CrosshairIcon } from '../PrepareMeetingIcons';

export const PrepareMeetingIntroCard = () => {
    const { t } = useTranslation();

    return (
        <div
            className={
                'mb-[112px] flex w-full max-w-[590px] items-start gap-3 rounded-2xl border border-white bg-white/45 px-[24px] py-[36px] backdrop-blur-[2px]'
            }
        >
            <div className={'flex items-start gap-[12px]'}>
                <div
                    className={
                        'flex h-[60px] w-[60px] flex-shrink-0 items-center justify-center rounded-full bg-[#eff6ff]'
                    }
                >
                    <CrosshairIcon
                        className={'h-[36px] w-[36px] text-[var(--color-primary-500)]'}
                    />
                </div>
                <div className={'flex-1'}>
                    <h3 className={'text-navy text-heading-sm! font-medium'}>
                        {t('postReviewPrepareMeeting.introCard.title')}
                    </h3>
                    <p className={'text-navy text-body-sm! mt-4'}>
                        {t('postReviewPrepareMeeting.introCard.subtitle')}
                    </p>
                </div>
            </div>
        </div>
    );
};
